import React, { useRef, Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import "./App.css";
import ProjectLoader from "./ProjectLoader";

// Lazy load all route components
const Master = lazy(() => import("./Master"));

const EarthoTour = lazy(() => import("./Eartho/Tour"));
const EarthoMap = lazy(() => import("./Eartho/Components/Map"));

const GardeniaTour = lazy(() => import("./saiGardenia/Tour"));
const GardeniaMap = lazy(() => import("./saiGardenia/Components/Map"));

const GardensTour = lazy(() => import("./slvGardens/Tour"));
const GardensMap = lazy(() => import("./slvGardens/Components/Map"));

const SlvFarmland = lazy(() => import("./slvFarmland/Tour"));

// Kept dark rather than white: the master plan preloads a tour's chunk before
// navigating, so this is usually a single frame - and against the tours' black
// canvas a dark frame is invisible where a white one read as a flash.
function RouteLoader() {
  return <ProjectLoader />;
}

function App() {
  const mountRef = useRef(null);

  return (
    <div
      ref={mountRef}
      className="app-container"
      style={{ width: "100vw", height: "100vh", overflow: "hidden" }}
    >
      <Suspense fallback={<RouteLoader />}>
        <Routes>
          {/* Home */}
          <Route path="/" element={<Master />} />

          {/* Eartho */}
          <Route path="/project/eartho" element={<EarthoTour />} />
          <Route path="/project/eartho/map" element={<EarthoMap />} />

          {/* Sai Gardenia */}
          <Route path="/project/slvgardenia" element={<GardeniaTour />} />
          <Route path="/project/slvgardenia/map" element={<GardeniaMap />} />

          {/* SLV Gardens */}
          <Route path="/project/slvgardens" element={<GardensTour />} />
          <Route path="/project/slvgardens/map" element={<GardensMap />} />

          {/* SLV Farmland */}
          <Route path="/project/slvfarmland" element={<SlvFarmland />} />

          {/* fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </div>
  );
}

export default function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}
